import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link as ScrollLink, scroller } from "react-scroll";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";


const NavBar = () => {
  const [nav, setNav] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isMainPage = location.pathname === "/";

  useEffect(() => {
    if (isMainPage) {
      const handleScroll = () => {
        const targetElement = localStorage.getItem('scrollTarget');
        if (targetElement) {
          scroller.scrollTo(targetElement, {
            duration: 500,
            smooth: true
          });
          localStorage.removeItem('scrollTarget');
        }
      };

      if (document.readyState === 'complete') {
        handleScroll();
      } else {
        window.addEventListener('load', handleScroll);
        return () => window.removeEventListener('load', handleScroll);
      }
    }
  }, [isMainPage, location]);

  const links = [
    {
      id: 1,
      link: "Home",
      path: "/",
      element: "Forside"
    },
    {
      id: 2,
      link: "About",
      path: "/",
      element: "Om"
    },
    {
      id: 3,
      link: "Services",
      path: "/",
      element: "Services"
    },
    {
      id: 4,
      link: "Products",
      path: "/",
      element: "Products"
    },
    {
      id: 5,
      link: "Articles",
      path: "/",
      element: "Artikler"
    },
    {
      id: 6,
      link: "Contact",
      path: "/",
      element: "Kontakt"
    },
  ];

  const handleNavigation = (element) => {
    if (!isMainPage) {
      localStorage.setItem('scrollTarget', element);
      navigate("/");
    }
  };

  const renderLink = (id, link, path, element) => {
    if (isMainPage) {
      return (
        <ScrollLink
          to={element}
          smooth
          duration={500}
          onClick={() => setNav(false)}
        >
          {link}
        </ScrollLink>
      );
    }
    return (
      <RouterLink 
        to={path} 
        onClick={() => {
          setNav(false);
          handleNavigation(element);
        }}
      >
        {link}
      </RouterLink>
    );
  };

  return (
    <div className="flex justify-between items-center w-full h-20 px-4 text-black bg-white fixed z-50">
      <div>
        <RouterLink to="/">
          <h1 className="text-xl font-signature ml-2">VILLINGER</h1>
        </RouterLink>
      </div>

      <ul className="hidden md:flex">
        {links.map(({ id, link, path, element }) => (
          <li
            key={id}
            className="px-4 cursor-pointer capitalize font-medium text-black hover:scale-105 duration-200"
          >
            {renderLink(id, link, path, element)}
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-black md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-black text-white">
          {links.map(({ id, link, path, element }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              {renderLink(id, link, path, element)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;